import { ReactNode } from "react";

import { Box } from "../MuiGenerals";

type BannerTone = "warning" | "info" | "success";

const TONE_SX: Record<BannerTone, { bg: string; border: string; color: string }> = {
  warning: { bg: "#FFFBEB", border: "#FCD34D", color: "#92400E" },
  info: { bg: "#F5F5F5", border: "#D9D9D9", color: "#595959" },
  success: { bg: "#F6FFED", border: "#B7EB8F", color: "#237804" },
};

interface InfoBannerProps {
  tone: BannerTone;
  icon?: ReactNode;
  children: ReactNode;
}

export default function InfoBanner({ tone, icon, children }: InfoBannerProps) {
  const sx = TONE_SX[tone];
  return (
    <Box
      sx={{
        backgroundColor: sx.bg,
        border: `1px solid ${sx.border}`,
        color: sx.color,
        borderRadius: "4px",
        padding: "10px 14px",
        fontSize: "13px",
        lineHeight: 1.6,
        display: "flex",
        alignItems: "flex-start",
        gap: "8px",
      }}
    >
      {icon && <span style={{ flexShrink: 0, marginTop: "2px" }}>{icon}</span>}
      <Box component="span" sx={{ flex: 1 }}>
        {children}
      </Box>
    </Box>
  );
}